import { render } from "./IdentityTips.vue?vue&type=template&id=76b9c00d"
import script from "./IdentityTips.vue?vue&type=script&lang=js"
export * from "./IdentityTips.vue?vue&type=script&lang=js"

import "./IdentityTips.vue?vue&type=style&index=0&id=76b9c00d&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__